// extracted by mini-css-extract-plugin
export default {"link":"_E-z","disabled":"aF-z"};